import React from 'react'

function HeaderSpace() {
  return (
    <div className='header_space'></div>
  )
}

export default HeaderSpace